/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getQueueConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { issueListSsrResource } from '@jira/router-resources__service-desk-queues/src/queuesNavigationItems.tsx';
import { servicedeskQueuesEditRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskQueuesEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ServiceDeskQueuesEditView, { LazyServicedeskQueuesEditView } from './ui/edit-view/index.tsx';
import { ServicedeskQueuesConfig, LazyServicedeskQueuesConfig } from './ui/queues-config/index.tsx';
import { serviceDeskQueuesConfigPageEntryPoint } from './ui/queues-config-page-entry-point/index.tsx';

// TODO: Remove the `forPaint` and `component` properties when jsm_views_inside_queues_-_main_flag is cleaned up
export const servicedeskQueuesEditRouteEntry: Route = createEntry(
	servicedeskQueuesEditRoute,
	() => ({
		group: 'servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			() => fg('jsm_views_inside_queues_-_main_flag'),
			ServicedeskQueuesConfig,
			ServiceDeskQueuesEditView,
		),

		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			issueListSsrResource,
			...getQueuesResources(),
			getConsolidationStateResource(),
			...getQueueConfigResource(),
		],

		forPaint: [
			LazyAtlassianNavigation,
			fg('jsm_views_inside_queues_-_main_flag')
				? LazyServicedeskQueuesConfig
				: LazyServicedeskQueuesEditView,
		],

		ufoName: 'service-management.queues.edit',

		pageId: ({ query, match }) =>
			fg('jsm_views_inside_queues_-_main_flag')
				? `spa-apps/servicedesk/queues/views-config/${query.config}`
				: `spa-apps/servicedesk/queues/edit/${(match.params && match.params.queueId) || ''}`,

		entryPoint() {
			return fg('jsm_views_inside_queues_-_main_flag')
				? serviceDeskQueuesConfigPageEntryPoint
				: undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
